import type { MortgageRateResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import type { MortgageRateBand } from "web_myplann/Inspiration/OwnHome/Types/MortgageRateBand";
import { matchesMortgageRate } from "web_myplann/Shared/Utils/matchesMortgageRate";

type Args = {
	ltvPercent: number;
	amount: number;
	maturityYears: number;
};

export const selectMortgageRateBand = (
	rows: MortgageRateResponseDTO[],
	{ ltvPercent, amount, maturityYears }: Args,
): MortgageRateBand | null => {
	const ratesByBank = new Map<number, number>();

	for (const row of rows) {
		if (
			matchesMortgageRate(row, {
				ltv: ltvPercent,
				amount,
				years: maturityYears,
			})
		) {
			ratesByBank.set(row.bankId, row.rate);
		}
	}

	const rates = [...ratesByBank.values()];
	if (rates.length === 0) return null;

	return { best: Math.min(...rates), worst: Math.max(...rates) };
};
